var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileOffice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 34,
    viewBox: "0 0 30 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3333 33.6668H1.66667C1.22464 33.6668 0.800716 33.4912 0.488155 33.1787C0.175595 32.8661 0 32.4422 0 32.0002V2.00016C0 1.55814 0.175595 1.13421 0.488155 0.821651C0.800716 0.509091 1.22464 0.333496 1.66667 0.333496H28.3333C28.7754 0.333496 29.1993 0.509091 29.5118 0.821651C29.8244 1.13421 30 1.55814 30 2.00016V32.0002C30 32.4422 29.8244 32.8661 29.5118 33.1787C29.1993 33.4912 28.7754 33.6668 28.3333 33.6668ZM26.6667 30.3335V3.66683H3.33333V30.3335H26.6667ZM8.33333 8.66683H21.6667V12.0002H8.33333V8.66683ZM8.33333 15.3335H21.6667V18.6668H8.33333V15.3335ZM8.33333 22.0002H16.6667V25.3335H8.33333V22.0002Z",
    fill: "#888EA0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileOffice);
export default __webpack_public_path__ + "static/media/file-office.3dddfac8b279dc832c78dd218eb52b8c.svg";
export { ForwardRef as ReactComponent };